import { HStack, VStack, Icon, Button, Text, Box } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';
import { BsFillGiftFill } from 'react-icons/bs';
import { VscArrowRight } from 'react-icons/vsc';

import useNavigateCartRule from '../../../hooks/useNavigateCartRule';
import { getFormattedCurrency } from '../../../utils/business/prices';
import BottomOnglet from '../../generic/BottomOnglet';

const CartRules = ({ cartRules }) => {
  const { onCartRuleClick } = useNavigateCartRule();

  return (
    <BottomOnglet
      title={<Trans>Promotions are available!</Trans>}
      titleIcon={BsFillGiftFill}
      brandColor="brand.color_cart_rules"
      openByDefault
      // hard values that depend on the cart rules below, we display 2max then scroll
      collapsedHeight={60}
      expandedHeight={cartRules.length == 1 ? 185 : 285}
    >
      {cartRules.map(cartRule => (
        <Box key={cartRule.id} w="full" p="4" my="2" borderWidth="1px" borderColor="gray.200" borderRadius="md" _hover={{ borderColor: 'gray.300' }}>
          <HStack justify="space-between" align="center" spacing="4">
            <VStack align="flex-start" spacing="1">
              <Text fontWeight="bold" fontSize="lg" color="brand.color_cart_rules">
                {cartRule.percentage ? `-${cartRule.promotion}%` : `-${getFormattedCurrency(cartRule.promotion)}`}
              </Text>
              <Text fontSize="sm" noOfLines={5}>
                {cartRule.promo_label}
              </Text>
            </VStack>

            <Button
              bg="brand.color_cart_rules"
              flexShrink="0"
              size="sm"
              onClick={() => onCartRuleClick(cartRule)}
              rightIcon={<Icon as={VscArrowRight} />}
            >
              <Trans>Claim</Trans>
            </Button>
          </HStack>
        </Box>
      ))}
    </BottomOnglet>
  );
};

export default CartRules;
